import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import map from "lodash/map";
export default (gridRef, format, documentName) => () => {
    var _a;
    if (!((_a = gridRef === null || gridRef === void 0 ? void 0 : gridRef.current) === null || _a === void 0 ? void 0 : _a.instance))
        return;
    const fileName = documentName || "unknown";
    const workbook = new Workbook();
    const options = {
        component: gridRef.current.instance,
        worksheet: workbook.addWorksheet(fileName),
        autoFilterEnabled: true,
        encodeExecutableContent: true,
        customizeCell: (customizeCellOptions) => {
            if (customizeCellOptions === null || customizeCellOptions === void 0 ? void 0 : customizeCellOptions.excelCell) {
                customizeCellOptions.excelCell.alignment = { horizontal: "left" };
            }
        }
    };
    const callback = (buffer) => {
        saveAs(new Blob([buffer], {
            type: format === "csv" ? "text/csv;charset=utf-8" : "application/octet-stream"
        }), `${fileName}.${format}`);
    };
    const csvWriteBufferOptions = {
        formatterOptions: {
            objectMode: true,
            writeBOM: true,
            delimiter: ",",
            quote: false,
            alwaysWriteHeaders: true,
            transform: (row) => map(row, el => `"${el}"`)
        }
    };
    exportDataGrid(options).then(() => {
        if (format === "csv") {
            workbook.csv.writeBuffer(csvWriteBufferOptions).then(callback);
        }
        else {
            workbook.xlsx.writeBuffer().then(callback);
        }
    });
};
